import { render } from "./PoiGz.vue?vue&type=template&id=578b3f4e&scoped=true"
import script from "./PoiGz.vue?vue&type=script&lang=js"
export * from "./PoiGz.vue?vue&type=script&lang=js"

import "./PoiGz.vue?vue&type=style&index=0&id=578b3f4e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578b3f4e"]])

export default __exports__